import React from "react";
import { useDrag, useDrop } from "react-dnd";

const styles = {
  container: {
    height: 125,
    width: 250,
    border: "1px solid black",
    margin: 5,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    backgroundColor: 'white'
  }
};

const ItemTypes = {
  IMAGEPREVIWER: "imagepreviewer"
};

const imagePreviewer = React.forwardRef(({
  index,
  id,
  imageUrl,
  onDragCompleted
},ref) => {

  const dragRef = React.useRef(null);
  const [, drop] = useDrop({
    accept: ItemTypes.IMAGEPREVIWER,
    hover(item, monitor) {
      if (!dragRef.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = dragRef.current.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      if(onDragCompleted){//maybe its better to throw an error?
        onDragCompleted(dragIndex, hoverIndex); 
      }
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    }
  });

  const [{ isDragging }, drag] = useDrag({
    item: { type: ItemTypes.IMAGEPREVIWER, id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  const opacity = isDragging ? 0 : 1;

  drag(drop(dragRef));

  return (
    <div
      style={{
        ...styles.container,
        opacity: opacity
      }}
      ref={dragRef}
    >
      <input
        type="checkbox"
        ref={ref}
      />
      <img
        src={imageUrl}
        alt={`preview`}
        style={{ height: 100, width: 200, margin: 12 }}
      ></img>
    </div>
  );
});


export default imagePreviewer;